// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"369":"8c5ab054","981":"ccfa3c41"}[chunkId] + ".chunk.css";
};